import React, { useCallback, useEffect } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Img
import eventIcon from "../../../assets/svg/sidepanel/events.svg";
import guestIcon from "../../../assets/svg/sidepanel/guests.svg";
import photosIcon from "../../../assets/svg/sidepanel/photos.svg";
import qrCodeIcon from "../../../assets/svg/sidepanel/qr-code.svg";

// css
import classes from "./Sidepanel.module.css";

// Jds
import {
  Accordion,
  AccordionPanel,
  ActionButton,
  Container,
  Icon,
  Text,
  Tooltip,
} from "@jds/core";
import useApiHttp from "../../../hooks/use-http";
import { setSidebarDetails } from "../../../store/state-slices/eventDetails";
import { Skeleton } from "@mui/material";

export default function Sidepanel(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const { sendRequest: getEventDetails, isLoading } = useApiHttp();
  const handleNavigateHome = useCallback(() => {
    navigate("/home");
  }, []);

  const isAdmin = eventDetails?.userRole == "ADMIN";
  const isPhotographer = eventDetails?.userRole == "PHOTOGRAPHER";

  useEffect(() => {
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        dispatch(setSidebarDetails({ eventDetails: data?.data }));
      }
    );
  }, [eventId]);
  return (
    <Container
      width="264px"
      style={{
        boxShadow: "var(--box-shadow-card)",
        padding: "32px 24px",
        height: "calc(100vh - 80.95px)",
        position: "sticky",
        top: "72px",
        marginTop: "72px",
      }}
      overflow="auto"
      direction="column"
      gap={16}
    >
      <Container
        style={{ padding: "20px 0px" }}
        fullWidth
        direction="row"
        verticalAlign="center"
      >
        <Tooltip label="Home" position="bottom">
          <ActionButton
            icon={"IcHome"}
            onClick={handleNavigateHome}
            size="small"
          />
        </Tooltip>
        {isLoading ? (
          <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100%" }} />
        ) : (
          <Tooltip label={eventDetails?.name} position="bottom">
            <Text
              text={eventDetails?.name}
              appearance="body-m-bold"
              maxLines={2}
            />
          </Tooltip>
        )}
      </Container>
      <ul className={classes["nav__list"]}>
        <li className={classes["nav__item"]}>
          <NavLink
            className={classes["nav__link"]}
            to={`/home/events/event-detail/${eventId}`}
            style={({ isActive }) => {
              return {
                backgroundColor: isActive ? "var(--color-primary-20)" : "",
              };
            }}
          >
            <Icon ic={"IcCelebration"} kind="background" size="large" />
            <Text text="Events" appearance="" color="primary_grey_80" />
          </NavLink>
        </li>
        {/* <li className={classes["nav__item"]}>
          <NavLink
            className={classes["nav__link"]}
            to={`/home/events/guests/${eventId}`}
            style={({ isActive }) => {
              return {
                backgroundColor: isActive ? "var(--color-primary-20)" : "",
              };
            }}
          >
            <Icon ic={"IcGroup"} kind="background" size="large" />

            <Text text="Guests" appearance="" color="primary_grey_80" />
          </NavLink>
        </li> */}
        {isPhotographer && (
          <li className={classes["nav__item"]}>
            <NavLink
              className={classes["nav__link"]}
              to={`/home/events/albums/${eventId}`}
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "var(--color-primary-20)" : "",
                };
              }}
            >
              <Icon ic={"IcPhoto"} kind="background" size="large" />
              <Text text="Albums" appearance="" color="primary_grey_80" />
            </NavLink>
          </li>
        )}

        {isAdmin && (
          <>
            <li
              className={`${classes["nav__item"]} ${classes["nav__item--accordion"]}`}
            >
              <Accordion expanded={[0]}>
                <AccordionPanel
                  title="Users"
                  prefix={
                    <Icon ic={"IcGroup"} kind="background" size="large" />
                  }
                  showDivider={false}
                >
                  <Container direction="column" gap={8} flex={1}>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/guests/${eventId}`}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}
                    >
                      <Text
                        text="Guests"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                    {/* <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/photographers/${eventId}`}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}
                    >
                      <Text
                        text="Photographers"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink> */}
                  </Container>
                </AccordionPanel>
              </Accordion>
            </li>
            <li
              className={`${classes["nav__item"]} ${classes["nav__item--accordion"]}`}
            >
              <Accordion expanded={[0]}>
                <AccordionPanel
                  title="Photos"
                  prefix={
                    <Icon ic={"IcPhoto"} kind="background" size="large" />
                  }
                  showDivider={false}
                >
                  <Container direction="column" gap={8} flex={1}>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/albums/${eventId}`}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}
                    >
                      <Text
                        text="Albums"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                    <NavLink
                      className={classes["nav__link"]}
                      to={`/home/events/faces/${eventId}`}
                      style={({ isActive }) => {
                        return {
                          backgroundColor: isActive
                            ? "var(--color-primary-20)"
                            : "",
                        };
                      }}
                    >
                      <Text
                        text="Faces"
                        appearance=""
                        color="primary_grey_80"
                      />
                    </NavLink>
                  </Container>
                </AccordionPanel>
              </Accordion>
            </li>

            {/* <li className={classes["nav__item"]}>
              <NavLink
                className={classes["nav__link"]}
                to={`/home/events/qr/${eventId}`}
                style={({ isActive }) => {
                  return {
                    backgroundColor: isActive ? "var(--color-primary-20)" : "",
                  };
                }}
              >
                <Icon ic={"IcQrCode"} kind="background" size="large" />
                <Text
                  text="Generate QR Code"
                  appearance=""
                  color="primary_grey_80"
                />
              </NavLink>
            </li> */}
            <li className={classes["nav__item"]}>
              <NavLink
                className={classes["nav__link"]}
                to={`/home/events/share/${eventId}`}
                style={({ isActive }) => {
                  return {
                    backgroundColor: isActive ? "var(--color-primary-20)" : "",
                  };
                }}
              >
                <Icon ic={"IcShare"} kind="background" size="large" />

                <Text
                  text="Share photos"
                  appearance=""
                  color="primary_grey_80"
                />
              </NavLink>
            </li>
            {isAdmin && (
              <li className={classes["nav__item"]}>
                <NavLink
                  className={classes["nav__link"]}
                  to={`/home/events/settings/${eventId}`}
                  style={({ isActive }) => {
                    return {
                      backgroundColor: isActive
                        ? "var(--color-primary-20)"
                        : "",
                    };
                  }}
                >
                  <Icon ic={"IcSettings"} kind="background" size="large" />

                  <Text text="Settings" appearance="" color="primary_grey_80" />
                </NavLink>
              </li>
            )}
            <li className={classes["nav__item"]}>
              <NavLink
                className={classes["nav__link"]}
                to={`/home/events/analytics/${eventId}`}
                style={({ isActive }) => {
                  return {
                    backgroundColor: isActive ? "var(--color-primary-20)" : "",
                  };
                }}
              >
                <Icon
                  ic={"IcAnalyticsPieChart"}
                  kind="background"
                  size="large"
                />

                <Text text="Analytics" appearance="" color="primary_grey_80" />
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </Container>
  );
}
